import React from 'react';
import { connect } from 'react-redux';
import { withTranslation, WithTranslation } from 'react-i18next';
import { ApplicationState } from '../../store';

//component state
interface IStateProps {

}

//component props
interface IOwnProps {
    stockQty: number
}

//redux state props
interface IReduxStateProps {

}

interface IReduxDispatchProps {

}

type Props = IOwnProps & IReduxStateProps & IReduxDispatchProps & WithTranslation;

class OnStock extends React.PureComponent<Props, IStateProps> {

    render() {

        return <React.Fragment>
            <span className="onStock">{ this.props.t( 'product.onStock.label' ) } { this.props.stockQty <= 5 ? this.props.stockQty + ' ks' : '> 5 ks' }</span>
        </React.Fragment>;
    }
}

const mapStateToProps = ( state: ApplicationState ): IReduxStateProps => ( {

} );

const mapDispatchToProps = ( dispatch: Function ): IReduxDispatchProps => ( {

} );

export default connect<IReduxStateProps, IReduxDispatchProps, IOwnProps, ApplicationState>(
    mapStateToProps,
    mapDispatchToProps
)( withTranslation()( OnStock ) );


